import { useEffect, useRef } from 'react'
import { track } from '../utils/tracking'

const MILESTONES = [25, 50, 75, 90]

/** Fires a `scroll_depth` tracking event once per milestone. */
export function useScrollDepth(): void {
  const fired = useRef<Set<number>>(new Set())

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement
      const scrollable = doc.scrollHeight - window.innerHeight
      if (scrollable <= 0) return
      const percent = (window.scrollY / scrollable) * 100

      MILESTONES.forEach((milestone) => {
        if (percent >= milestone && !fired.current.has(milestone)) {
          fired.current.add(milestone)
          track('scroll_depth', { percent: milestone })
        }
      })
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
}
